var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-viewer"},[_c('div',{staticClass:"canvas-container"},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }